(function () {
  const MOBILE_LP_QUERY = '(max-width: 880px)';
  const MOBILE_BUY_HASH_IDS = ['ritual', 'buy'];

  function getNavHeight() {
    const nav = document.querySelector('.lp-editorial-nav');
    const cssHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--lp-editorial-nav-height')
    );

    if (cssHeight) return cssHeight;
    return nav ? nav.offsetHeight : 0;
  }

  function getReservedStickyBarHeight() {
    const bar = document.querySelector('.lp-editorial-sticky-bar');
    if (!bar) return 0;

    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const enabled = isDesktop
      ? bar.dataset.showDesktop === 'true'
      : bar.dataset.showMobile === 'true';

    if (!enabled) return 0;

    const cssHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--lp-editorial-sticky-bar-height')
    );

    return bar.offsetHeight || cssHeight || 0;
  }

  function scrollMobileBuyTarget(target, behavior) {
    const gap = 48;
    const mode = target.dataset.lpBuyScrollMode || 'bottom';

    const scrollOnce = () => {
      const rect = target.getBoundingClientRect();
      const stickyBar = getReservedStickyBarHeight();
      let top;

      if (mode === 'top') {
        const offset = getNavHeight() + 16;
        top = window.scrollY + rect.top - offset;
      } else {
        top = window.scrollY + rect.bottom - window.innerHeight + stickyBar + gap;
      }

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: behavior === 'auto' ? 'auto' : 'smooth'
      });
    };

    scrollOnce();

    requestAnimationFrame(() => {
      requestAnimationFrame(scrollOnce);
    });

    window.setTimeout(scrollOnce, 450);
  }

  function isMobileLpView() {
    return window.matchMedia(MOBILE_LP_QUERY).matches;
  }

  function isMobileBuyHash(id) {
    return MOBILE_BUY_HASH_IDS.includes(id) && isMobileLpView();
  }

  function resolveMobileBuyTarget(id) {
    const section = document.getElementById(id);
    if (!section) return null;

    return (
      section.querySelector('[data-lp-buy-scroll-target]') ||
      section.querySelector('[data-lp-ritual-scroll-target]') ||
      section.querySelector('.lp-editorial-ritual__atc') ||
      section.querySelector('.lp-editorial-shop__grid') ||
      section
    );
  }

  function isMobileBuyScrollTarget(target) {
    return (
      target.matches('[data-lp-buy-scroll-target]') ||
      target.matches('[data-lp-ritual-scroll-target]') ||
      target.classList.contains('lp-editorial-ritual__atc') ||
      target.classList.contains('lp-editorial-shop__grid')
    );
  }

  function resolveScrollTarget(hash) {
    if (!hash || hash === '#') return null;

    const id = hash.slice(1);
    if (!id) return null;

    if (isMobileBuyHash(id)) {
      return resolveMobileBuyTarget(id);
    }

    return document.getElementById(id);
  }

  function scrollToHash(hash, behavior) {
    const target = resolveScrollTarget(hash);
    if (!target || typeof target.getBoundingClientRect !== 'function') return false;

    const scrollBehavior =
      behavior ||
      (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

    const id = hash.slice(1);
    const isMobileBuyTarget =
      isMobileBuyHash(id) && isMobileBuyScrollTarget(target);

    if (isMobileBuyTarget) {
      scrollMobileBuyTarget(target, scrollBehavior);

      if (history.pushState) {
        history.pushState(null, '', hash);
      } else {
        window.location.hash = hash;
      }

      return true;
    }

    const offset = getNavHeight() + 16;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: scrollBehavior
    });

    if (history.pushState) {
      history.pushState(null, '', hash);
    } else {
      window.location.hash = hash;
    }

    return true;
  }

  function initAnchorLinks(root) {
    (root || document).querySelectorAll('a[href^="#"]').forEach((link) => {
      if (link.dataset.lpEditorialAnchorInit === 'true') return;

      const hash = link.getAttribute('href');
      if (!hash || hash === '#') return;

      const id = hash.slice(1);
      if (!document.getElementById(id) && !MOBILE_BUY_HASH_IDS.includes(id)) return;

      link.dataset.lpEditorialAnchorInit = 'true';

      link.addEventListener('click', (event) => {
        if (!scrollToHash(hash)) return;
        event.preventDefault();
      });
    });
  }

  function initNav(nav) {
    if (!nav || nav.dataset.lpEditorialNavInit === 'true') return;

    const section = nav.closest('.shopify-section');
    const spacer = section?.querySelector('.lp-editorial-nav__spacer');
    if (!spacer) return;

    nav.dataset.lpEditorialNavInit = 'true';

    const setHeight = () => {
      const height = nav.offsetHeight;
      document.documentElement.style.setProperty('--lp-editorial-nav-height', `${height}px`);
      spacer.style.height = `${height}px`;
    };

    setHeight();

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setHeight).observe(nav);
    } else {
      window.addEventListener('resize', setHeight);
    }
  }

  function initHashOnLoad() {
    const hash = window.location.hash;
    if (!hash || hash === '#') return;

    requestAnimationFrame(() => {
      scrollToHash(hash, 'auto');
    });
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('.lp-editorial-nav').forEach(initNav);
    initAnchorLinks(scope);

    if (!root) {
      initHashOnLoad();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  window.addEventListener('hashchange', () => {
    if (window.location.hash) {
      scrollToHash(window.location.hash, 'auto');
    }
  });
})();
